import React, { useState } from "react";
import RootBulkModal from "./bulkModal";
import Loader from "../../../../components/common/Loader";
import { bulkPromiseDateEdit } from "../../../../features/actions/bulkOperationApi";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Form, Formik } from "formik";
import { FtextField } from "../../../../components/common/FtextField";
import useDataInputOption from "../../../../hooks/useDataInputOption";
import { bulkResellerCustomerPromiseDateUpdate } from "../../../../features/resellerCustomerAdminApi";

const BulkResellerCustomerPromiseDateUpdate = ({
  bulkCustomer,
  show,
  setShow,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const inputPermission = {
    promiseDate: true,
  };

  // get data input option from useDataInputOption hook
  const dataInputOption = useDataInputOption(
    inputPermission,
    null,
    "edit",
    null,
  );

  //---> Local State
  const [isLoading, setIsLoading] = useState();

  const promiseDateHandler = ({ promiseDate }) => {
    const data = {
      customerIds: bulkCustomer,
      promiseDate: promiseDate.toISOString(),
    };

    bulkResellerCustomerPromiseDateUpdate(
      dispatch,
      data,
      setIsLoading,
      setShow,
    );
  };

  return (
    <RootBulkModal show={show} setShow={setShow} header={t("editPromiseDate")}>
      <Formik
        initialValues={{
          ...dataInputOption.inputInitialValues,
        }}
        validationSchema={dataInputOption?.validationSchema}
        onSubmit={(values) => promiseDateHandler(values)}
        enableReinitialize
      >
        {() => (
          <Form>
            <div className="displayGrid">
              {dataInputOption?.inputOption.map(
                (item) => item?.isVisible && <FtextField {...item} />,
              )}
            </div>

            <div className="displayGrid1 float-end mt-3">
              <button
                type="button"
                className="btn btn-secondary border-0"
                disabled={isLoading}
                onClick={() => setShow(false)}
              >
                {t("cancel")}
              </button>

              <button
                type="submit"
                className="btn btn-success border-0"
                disabled={isLoading}
              >
                {isLoading ? <Loader /> : t("submit")}
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </RootBulkModal>
  );
};

export default BulkResellerCustomerPromiseDateUpdate;
